import Loading from './_loading.js'
import Stop from './_stop.js'

import template from './index.pug'

// @vue/component
export default Vue.extend({
  name: 'routes-list-page',
  template: template(),
  components: {Loading, Stop},

  props: {
    stops: {
      type: Array,
      required: true
    },

    selectedStopId: {
      type: String,
      default: undefined
    }
  },

  methods: {
    selectStop(stop) {
      this.$emit('select-stop', stop)
    }
  }
})
